import { HeadContent, Outlet } from '@tanstack/react-router'
import { NuqsAdapter } from 'nuqs/adapters/tanstack-router'
import { Suspense } from 'react'

import AppDeviceInfoProvider from '@/components/app-shell/provider/app.device-info.provider'
import AppOrderSession from '@/components/app-session/provider/app.order-session.provider'
import { AppStoreProvider } from '@/components/stores'
import AppScanFromProvider from '@/components/stores/provider/app.scan-from.provider'

const RouterRoot = () => (
  <>
    <HeadContent />
    <NuqsAdapter>
      <AppDeviceInfoProvider>
        <AppOrderSession>
          <Suspense fallback={<div style={{ minHeight: '100vh' }} />}>
            <AppScanFromProvider>
              <AppStoreProvider>
                <Outlet />
              </AppStoreProvider>
            </AppScanFromProvider>
          </Suspense>
        </AppOrderSession>
      </AppDeviceInfoProvider>
    </NuqsAdapter>
  </>
)

export default RouterRoot
